import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const SupportTickets = lazy(() => import('../../pages/Support/SupportTicketsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<SupportTickets />} />
    </Routes>
  );
}

export default PagesRoute;
